import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { ColumnConfig, ColumnKey } from './constants';

interface HiddenColumnsToggleProps {
  visibleColumns: Set<ColumnKey>;
  columnConfigs: ColumnConfig[];
  onToggle: () => void;
}

const HiddenColumnsToggle: React.FC<HiddenColumnsToggleProps> = ({
  visibleColumns,
  columnConfigs,
  onToggle,
}) => {
  const hiddenColumns = columnConfigs.filter((config) => config.hiddenByDefault);
  const hiddenColumnsCount = hiddenColumns.length;
  const allColumnsVisible = visibleColumns.size === columnConfigs.length;

  return (
    <button
      onClick={onToggle}
      className="text-xs px-2 py-1 text-gray-600 hover:text-blue-600 flex items-center gap-1"
      title={allColumnsVisible ? 'Hide optional columns' : 'Show all columns'}
    >
      {allColumnsVisible ? (
        <>
          <EyeSlashIcon className="w-4 h-4" />
          Hide {hiddenColumnsCount} columns
        </>
      ) : (
        <>
          <EyeIcon className="w-4 h-4" />
          Show {hiddenColumnsCount} hidden columns
        </>
      )}
    </button>
  );
};

export default HiddenColumnsToggle;
